import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/PublicLegalPage.module.css';
import PublicLegalFooter from '../components/PublicLegalFooter';

const TermsOfServicePage = () => (
  <div className={styles.container}>
    <div className={styles.content}>
      <h1 className={styles.title}>Terms of Service</h1>
      <p className={styles.subtitle}>Last updated: July 24, 2026</p>

      <section className={styles.section}>
        <h2>Agreement</h2>
        <p>
          By accessing or using LOTW League (&quot;the Service&quot;), you agree to these Terms of
          Service. The Service is a private league management tool for a college football pick&apos;em
          league operated at lotwleague.com.
        </p>
      </section>

      <section className={styles.section}>
        <h2>Eligibility &amp; Accounts</h2>
        <ul>
          <li>Access is limited to league members with approved accounts</li>
          <li>You are responsible for maintaining the confidentiality of your login credentials</li>
          <li>You agree to provide accurate account information</li>
          <li>League administrators may suspend or remove accounts that violate league rules</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2>Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Attempt to gain unauthorized access to the Service or other users&apos; accounts</li>
          <li>Interfere with the operation or security of the Service</li>
          <li>Use the Service for unlawful purposes</li>
          <li>Harass other league members through any communication channel connected to the Service</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2>SMS &amp; Communications</h2>
        <p>
          SMS is <strong>not required</strong> to use the Service. You may access all core league
          features without providing a mobile phone number or opting in to text messages.
        </p>
        <p>
          Optional SMS features are governed by a separate{' '}
          <Link to="/sms-opt-in" className={styles.link}>SMS Opt-In</Link> process — not by accepting
          these Terms. Only if you voluntarily opt in do you consent to receive transactional
          messages as described there, including verification codes, password reset codes, and
          optional pick reminders. Message frequency varies (max 4 msgs/month). Message and data
          rates may apply. Reply STOP to opt out. Reply HELP for assistance.
        </p>
      </section>

      <section className={styles.section}>
        <h2>Disclaimer</h2>
        <p>
          The Service is provided &quot;as is&quot; for league entertainment and organization. We do
          not guarantee uninterrupted availability. LOTW League is a social pick&apos;em tool and does
          not facilitate gambling or wagering.
        </p>
      </section>

      <section className={styles.section}>
        <h2>Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, LOTW League and its operators shall not be liable
          for indirect, incidental, or consequential damages arising from use of the Service.
        </p>
      </section>

      <section className={styles.section}>
        <h2>Privacy</h2>
        <p>
          Our <Link to="/privacy" className={styles.link}>Privacy Policy</Link> explains how we handle
          your data, including mobile phone numbers used for SMS.
        </p>
      </section>

      <section className={styles.section}>
        <h2>Changes</h2>
        <p>
          We may modify these terms at any time. Material changes will be reflected by updating the
          date above. Continued use constitutes acceptance.
        </p>
      </section>

      <PublicLegalFooter />
    </div>
  </div>
);

export default TermsOfServicePage;
